import React, { useEffect, useRef, useState } from "react";
import { FaWhatsapp, FaFacebook, FaInstagram } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
export default function Footer() {
  const footerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setIsVisible(true);
        });
      },
      { threshold: 0.2 }
    );
    if (footerRef.current) observer.observe(footerRef.current);
    return () => {
      if (footerRef.current) observer.unobserve(footerRef.current);
    };
  }, []);
  const handleAppointment = () => {
    navigate("/appointment");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <footer ref={footerRef} className={`footer ${isVisible ? "animate" : ""}`}>
      <div className="footer-container">
        {/* Left Logo & Social */}
        <div className="footer-left fade-up" style={{ transitionDelay: "0.2s" }}>
          <h2 className="footer-logo">Krisara</h2>
          <div className="footer-socials">
            <a href="https://www.facebook.com/p/Krisara-Gastro-and-Liver-Clinic-61568228834263/" aria-label="Facebook"><FaFacebook /></a>
            <a href="https://wa.link/zm2yn8" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
            <a href="https://www.instagram.com/dr_shruti.sagar/" aria-label="Instagram"><FaInstagram /></a>
          </div>
          <ul className="footer-legal">
            <li><a href="#">Privacy Policy</a></li>
            <li><a href="#">Terms & Conditions</a></li>
            <li>@Krisara | Gastroenterology</li>
          </ul>
        </div>
        {/* Middle Columns */}
        <div className="footer-links">
          <div className="footer-col fade-up" style={{ transitionDelay: "0.4s" }}>
            <h4>About</h4>
            <ul>
              <li><a href="/doctor">About Dr. Shruti Sagar</a></li>
              <li><a href="/about">Clinic Overview</a></li>
              <li><a href="/about">Our Approach</a></li>
              <li><a href="/testimonials">Testimonials</a></li>
            </ul>
          </div>
          <div className="footer-col fade-up" style={{ transitionDelay: "0.6s" }}>
            <h4>Services</h4>
            <ul>
              <li><a href="/services">Upper GI Endoscopy</a></li>
              <li><a href="/services">Colonoscopy</a></li>
              <li><a href="/services">Liver FibroScan</a></li>
              <li><a href="/services">GERD & Acid Reflux Care</a></li>
              <li><a href="/services">IBS Management</a></li>
              <li><a href="/services">Peptic Ulcer Treatment</a></li>
              <li><a href="/services">Hemorrhoids Care</a></li>
              <li><a href="/services">Contact for All Services</a></li>
            </ul>
          </div>
          <div className="footer-col fade-up" style={{ transitionDelay: "0.8s" }}>
            <h4>Patient Help</h4>
            <ul>
              <li><a href="/appointment">Book Appointment</a></li>
              <li><a href="#">Preparation Guides</a></li>
              <li><a href="#">Insurance & Payments</a></li>
              <li><a href="/faq">FAQs</a></li>
              <li><a href="#">Diet & Lifestyle Plans</a></li>
              <li><a href="#">Teleconsultation</a></li>
            </ul>
          </div>
        </div>
        {/* Right Buttons */}
        <div className="footer-right fade-up" style={{ transitionDelay: "1s" }}>
          <button className="footer-btn outline" onClick={handleAppointment}>
            📅 Take an Appointment
          </button>
          <a
            href="https://wa.link/zm2yn8" // Replace with your number
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="footer-btn filled">
              💬 Connect on Whatsapp
            </button>
          </a>
        </div>
      </div>
      {/* Bottom Disclaimer */}
      <div className="footer-disclaimer fade-up" style={{ transitionDelay: "1.2s" }}>
        © 2025 Krisara Gastro and Liver Clinic - Kompally, Hyderabad | Developed by{" "}
        <a
          href="https://ebintech.in"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#ccc", fontWeight: "500", fontSize: "16px" }}
        >
          Ebintech
        </a>
      </div>
    </footer>
  );
}